import React from "react";
import styled from "styled-components";
import { V3SegmentedControl, V3Text } from "@components/v3/primitives";

export type CurrencyFilter = "All" | "GBP" | "USD";
export type StatusFilter = "All" | "PRELAUNCH" | "LIVE_ALL";

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space.section.gap}px;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.sm}px;
`;

const CURRENCY_OPTIONS: { label: string; value: CurrencyFilter }[] = [
  { label: "All", value: "All" },
  { label: "GBP (£)", value: "GBP" },
  { label: "USD ($)", value: "USD" },
];

const STATUS_OPTIONS: { label: string; value: StatusFilter }[] = [
  { label: "All", value: "All" },
  { label: "Prelaunch", value: "PRELAUNCH" },
  { label: "Live", value: "LIVE_ALL" },
];

interface FilterBarProps {
  currency: CurrencyFilter;
  onCurrencyChange: (value: CurrencyFilter) => void;
  status: StatusFilter;
  onStatusChange: (value: StatusFilter) => void;
  /** Hidden when every deal shares one currency — the toggle would be inert. */
  showCurrencyFilter: boolean;
  /** Hidden unless there are both prelaunch and live deals to switch between. */
  showStatusFilter: boolean;
}

export const FilterBar = ({
  currency,
  onCurrencyChange,
  status,
  onStatusChange,
  showCurrencyFilter,
  showStatusFilter,
}: FilterBarProps): JSX.Element => (
  <Bar>
    {showCurrencyFilter ? (
      <Group>
        <V3Text
          variant="caption.sm-medium"
          style={{
            fontWeight: 600,
            fontSize: 11,
            lineHeight: "14px",
            letterSpacing: 2,
            textTransform: "uppercase",
          }}
          color="tertiary"
        >
          Currency
        </V3Text>
        <V3SegmentedControl
          options={CURRENCY_OPTIONS}
          value={currency}
          onChange={onCurrencyChange}
          label="Currency"
          testID="live-deals-v3-currency-filter"
        />
      </Group>
    ) : null}
    {showStatusFilter ? (
      <Group>
        <V3Text
          variant="caption.sm-medium"
          style={{
            fontWeight: 600,
            fontSize: 11,
            lineHeight: "14px",
            letterSpacing: 2,
            textTransform: "uppercase",
          }}
          color="tertiary"
        >
          Status
        </V3Text>
        <V3SegmentedControl
          options={STATUS_OPTIONS}
          value={status}
          onChange={onStatusChange}
          label="Status"
          testID="live-deals-v3-status-filter"
        />
      </Group>
    ) : null}
  </Bar>
);
